<template>
  <div :class="['menu-level', `level-${level.depth}`]">
    <!-- mobile -->
    <template v-if="!$root.isDesktop">
      <div v-if="level.parentItem" class="level-back">
        <a @click="backHandler"><lazy-icon icon="caret-left" scale="0.65" /> {{ level.parentTitle }}</a>
      </div>

      <div v-if="level.title" class="level-title">{{ level.title }}</div>

      <div class="level-content">
        <ul>
          <header-menu-item v-if="level.parentItem" v-bind="level.parentItem">{{ level.parentItem.text }}</header-menu-item>

          <header-menu-item v-for="item in level.items" :key="item.id" v-bind="item" v-on="$listeners">{{ item.text }}</header-menu-item>
        </ul>
      </div>

      <div v-if="$slots.metanavigation" class="level-metanavigation">
        <slot name="metanavigation" />
      </div>
    </template>

    <!-- desktop -->
    <template v-else>
      <div class="level-content" @mouseleave="blurHandler">
        <template v-if="level.depth === maxDepthLevel && level.groupedItems">
          <div class="row no-gutters">
            <div class="col" v-for="group in level.groupedItems" :key="group.id">
              <div class="content-group">
                <div class="group-title">{{ group.title }}</div>
                <ul>
                  <header-menu-item
                    v-for="item in group.items"
                    :key="item.id"
                    v-bind="item"
                    :hardHover="item.id === addon.item.id"
                    v-on="$listeners"
                    @menuitem:hover="hoverHandler"
                    >{{ item.text }}</header-menu-item
                  >
                </ul>
              </div>
            </div>

            <div class="col" v-if="level.groupedItems.length <= 1"></div>
            <div class="col" v-if="level.groupedItems.length <= 2"></div>
          </div>
        </template>

        <template v-else>
          <ul>
            <header-menu-item
              v-for="item in level.items"
              :key="item.id"
              v-bind="item"
              :hardHover="item.id === addon.item.id"
              v-on="$listeners"
              @menuitem:hover="hoverHandler"
              >{{ item.text }}</header-menu-item
            >
          </ul>

          <div v-if="level.depth === 2" class="content-addon">
            <div v-show="!addon.level && addon.image.src" class="addon-image">
              <a :href="level.parentItem.href">
                <img v-bind="addon.image" />
                <span v-if="addon.image.showlink">{{ addon.image.linktext }} <lazy-icon icon="arrow-long-right" /></span>
              </a>
            </div>

            <header-menu-level v-if="addon.level" :key="addon.item.level.id" :level="addon.item.level" />

            <b-button class="level-close" @click="closeLevel"><lazy-icon icon="add" rotate="45deg" /></b-button>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { COMPONENT_HEADERMENU_MAX_DEPTH_LEVEL } from '@/constants'

import HeaderMenuItem from '@/components/public/layout/HeaderMenuItem'

export default {
  name: 'HeaderMenuLevel',
  components: {
    HeaderMenuItem
  },
  props: {
    level: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      maxDepthLevel: COMPONENT_HEADERMENU_MAX_DEPTH_LEVEL,
      addon: {
        image: (this.level.parentItem || {}).img || {},
        item: {},
        level: null
      }
    }
  },
  methods: {
    backHandler(event) {
      this.$emit('menuitem:back', { event })
    },
    hoverHandler(item = {}) {
      if (this.level.depth === 2) {
        this.addon.item = item
        this.addon.level = item.level || null
      }
    },
    blurHandler() {
      this.addon.item = {}
      this.addon.level = null
    },
    closeLevel() {
      this.$root.$emit('headermenulevel:close')
    }
  }
}
</script>

<style lang="scss">
// mobile
$headermenu-level-padding-y: $grid-gutter-width * 0.5 !default;
$headermenu-level-padding-x: $grid-gutter-width * 0.5 !default;
$headermenu-level-bg: $beige !default;
$headermenu-level-box-shadow: inset map-get($shadows, 'header');

$headermenu-level-back-margin: 0 0 ($spacer * 1.5) !default;

$headermenu-level-title-padding-y: $spacer * 0.5 !default;
$headermenu-level-title-padding-x: 0 !default;
$headermenu-level-title-border: map-get($borders, 'base') !default;
$headermenu-level-title-font-size: $font-size-sm !default;
$headermenu-level-title-font-weight: $font-weight-bold !default;

$headermenu-level-metanavigation-border: map-get($borders, 'bold') !default;

// desktop
$headermenu-level-breakpoint: $desktop-breakpoint !default;

$headermenu-level2-padding-y: $spacer * 1.5 !default;
$headermenu-level2-padding-x: 0 !default;
$headermenu-level2-bg: $headermenu-level-bg !default;
$headermenu-level2-box-shadow: $headermenu-level-box-shadow !default;
$headermenu-level2-border: map-get($borders, 'header') !default;

$headermenu-level2-content-max-height: 60vh !default;
$headermenu-level2-content-addon-padding-y: 0 !default;
$headermenu-level2-content-addon-padding-x: $grid-gutter-width * 0.5 !default;
$headermenu-level2-content-list-width: 25% !default;
$headermenu-level2-content-addon-border: map-get($borders, 'base') !default;
$headermenu-level2-content-addon-image-text-gap: $spacer * 0.25 !default;

$headermenu-level2-close-top: $headermenu-level2-padding-y !default;
$headermenu-level2-close-right: $headermenu-level2-padding-x !default;
$headermenu-level2-close-padding: $spacer * 0.5 !default;
$headermenu-level2-close-border: map-get($borders, 'base') !default;
$headermenu-level2-close-size: $spacer * 0.75 !default;

$headermenu-level3-content-group-title-gap: $spacer * 1.8 !default;
$headermenu-level3-content-group-title-padding-y: 0 !default;
$headermenu-level3-content-group-title-padding-x: $spacer * 0.75 !default;
$headermenu-level3-content-group-title-font-size: $font-size-sm !default;
$headermenu-level3-content-group-title-font-weight: $font-weight-bold !default;
$headermenu-level3-content-group-title-color: $dark !default;

.header-menu {
  @include media-breakpoint-down(get-breakpoint-key($headermenu-level-breakpoint, -1)) {
    .menu-level {
      padding: $headermenu-level-padding-y $headermenu-level-padding-x;
      background-color: $headermenu-level-bg;
      box-shadow: $headermenu-level-box-shadow;

      .level-back {
        margin: $headermenu-level-back-margin;

        a {
          cursor: pointer;
        }
      }

      .level-title {
        padding: $headermenu-level-title-padding-y $headermenu-level-title-padding-x;
        border-bottom: $headermenu-level-title-border;
        font-size: $headermenu-level-title-font-size;
        font-weight: $headermenu-level-title-font-weight;
      }

      > .level-content {
        > ul {
          @include list-unstyled();
        }
      }

      > .level-metanavigation {
        &:before {
          display: block;
          content: '';
          margin: -1px ($headermenu-level-padding-x * -1) 0;
          border-bottom: $headermenu-level-metanavigation-border;
        }
      }
    }
  }

  @include media-breakpoint-up($headermenu-level-breakpoint) {
    .menu-level {
      > .level-content {
        ul {
          @include list-unstyled();
        }
      }

      &.level-1 {
        > .level-content {
          > ul {
            display: flex;
            justify-content: center;
            align-items: stretch;
          }
        }
      }

      &.level-2 {
        position: relative;
        padding: $headermenu-level2-padding-y $headermenu-level2-padding-x;

        &:before {
          display: block;
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          z-index: -1;
          width: 200vw;
          background-color: $headermenu-level2-bg;
          border-top: $headermenu-level2-border;
          border-bottom: $headermenu-level2-border;
          box-shadow: $headermenu-level2-box-shadow;
          transform: translate3d(-50%, 0, 0);
        }

        > .level-content {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          overflow: hidden;
          overflow-y: auto;
          max-height: $headermenu-level2-content-max-height;
          // to not crop item-hover-styles
          margin-left: -10px;
          padding-left: 10px;

          > ul {
            width: $headermenu-level2-content-list-width;
          }

          > .content-addon {
            padding: $headermenu-level2-content-addon-padding-y $headermenu-level2-content-addon-padding-x;
            width: 100% - $headermenu-level2-content-list-width;
            border-left: $headermenu-level2-content-addon-border;

            .addon-image {
              display: inline-block;
              text-align: right;

              a {
                display: block;
                font-weight: $font-weight-medium;

                span {
                  display: block;
                  margin-top: $headermenu-level2-content-addon-image-text-gap;
                }
              }
            }
          }
        }

        .level-close {
          position: absolute;
          top: $headermenu-level2-close-top;
          right: $headermenu-level2-close-right;
          padding: $headermenu-level2-close-padding;
          border: $headermenu-level2-close-border;
          border-radius: 50%;
          font-size: $headermenu-level2-close-size;
          line-height: 1;
        }
      }

      &.level-3 {
        .content-group {
          .group-title {
            margin-top: $headermenu-level3-content-group-title-gap * 0.5;
            margin-bottom: $headermenu-level3-content-group-title-gap * 0.5;
            padding: $headermenu-level3-content-group-title-padding-y $headermenu-level3-content-group-title-padding-x;
            font-size: $headermenu-level3-content-group-title-font-size;
            font-weight: $headermenu-level3-content-group-title-font-weight;
            color: $headermenu-level3-content-group-title-color;
          }
        }
      }
    }
  }
}
</style>
